import type { OptionEntity } from 'domain/entities/OptionEntity';
import {
    AutoCompleteInput,
    FormField,
    FormFieldRow,
    NumberInput,
    TextInput,
} from '../../components';

type RequiredFieldsSectionProps = {
    allStation: OptionEntity[];
    onStationSelect: (option: OptionEntity | undefined) => void;
    onStationBlur: (option: OptionEntity | undefined) => void;
};

export const RequiredFieldsSection = ({
    allStation,
    onStationSelect,
    onStationBlur,
}: RequiredFieldsSectionProps) => {
    return (
        <>
            <FormFieldRow>
                <FormField label="築年数" name="age_building" required>
                    <TextInput placeholder="例：5" suffix="年" type="number" maxLength={2} />
                </FormField>
                <FormField label="専有面積" name="area" required>
                    <NumberInput
                        placeholder="例：20.75"
                        addonAfter="m²"
                        max={999.99}
                        allowDecimal
                    />
                </FormField>
            </FormFieldRow>

            <FormFieldRow>
                <FormField label="最寄駅" name="station_cd" required>
                    <AutoCompleteInput
                        options={allStation}
                        placeholder="駅名を入力"
                        notFoundContent="該当するデータはありません。"
                        onSelect={onStationSelect}
                        onBlur={onStationBlur}
                    />
                </FormField>
                <FormField label="駅からの徒歩" name="on_foot_time" required>
                    <TextInput placeholder="例：10" suffix="分" type="number" maxLength={3} />
                </FormField>
            </FormFieldRow>
        </>
    );
};
